import MuiRadio from "@mui/material/Radio";
import MuiRadioGroup from "@mui/material/RadioGroup";

const Radio = MuiRadio;
const RadioGroup = MuiRadioGroup;

export default Radio;
export { RadioGroup };
